import tw from "twin.macro";

import TalkIcon from "../../assets/icons/talk.svg";
import TelephoneIcon from "../../assets/icons/telephone.svg";
import { useChatStatus } from "../../features/FortuneTeller/hooks/useChatStatus";
import { FortuneTeller } from "../../types";

const labelCss = tw`flex-center p-1 rounded-sm mb-1 h-[18px]`;
const labelTextCss = tw`text-[9px] tracking-[.26px] font-semibold`;

const iconCss = tw`svg mr-0.5`;

const chatStatusCss = {
  待機中: tw`bg-[#E68AB4] text-[#E68AB4] text-white`,
  鑑定中: tw`text-theme bg-blossom`,
  受付中: tw`text-[#E68AB4] border-[#E68AB4] border border-solid bg-white`,
  一時停止中: tw`text-secondary bg-gray`,
  NoLabel: tw`hidden`,
};

const telStatusCss = {
  待機中: tw`text-white bg-[#8D12B4]`,
  受付中: tw`text-[#8D12B4] border-[#8D12B4] border border-solid`,
  一時停止中: tw`text-secondary bg-gray`,
  NoLabel: tw`hidden`,
};

interface Props {
  fortuneTeller: FortuneTeller;
  onlyChat?: boolean;
  onlyTel?: boolean;
  className?: string;
}

export const StatusLabel = ({
  fortuneTeller,
  onlyChat,
  onlyTel,
  className,
}: Props) => {
  const { chatStatus, telStatus } = useChatStatus(fortuneTeller);

  return (
    <div tw="flex-center" className={className}>
      {!onlyTel && (
        <div tw="mr-2" css={[labelCss, chatStatusCss[chatStatus]]}>
          <TalkIcon css={iconCss} />
          <span css={labelTextCss}>{chatStatus}</span>
        </div>
      )}
      {!onlyChat && (
        <div css={[labelCss, telStatusCss[telStatus]]}>
          <TelephoneIcon css={iconCss} />
          <span css={labelTextCss}>{telStatus}</span>
        </div>
      )}
    </div>
  );
};
